<template>
    <div style="margin:30px;" id="canvas"></div>
</template>

<script>
export default {
    mounted() {
        const trace1 = {
            x: ["Total Children", "Dalit Children", "Adivasi Children"],
            y: [0.285, 0.3187, 0.4001],
            text: ['28.5%', '31.87%', '40.01%'],
            textposition: 'auto',
            name: "Census 2001",
            type: "bar",
            marker: {
                color: "#EB3978",
            },
        };
        const trace2 = {
            x: ["Total Children", "Dalit Children", "Adivasi Children"],
            y: [0.1829, 0.1938, 0.2257],
            text: ['18.29%', '19.38%', '22.57%'],
            textposition: 'auto',
            name: "Census 2011",
            type: "bar",
            marker: {
                color: "#0d2440",
            },
        };
        const data = [trace1, trace2];
        const layout = {
            barmode: "group",
            yaxis: {
                tickformat: ",.0%",
                range: [0, 0.51],
            },
            plot_bgcolor: '#ddefdd', paper_bgcolor: '#ddefdd'
        };
        Plotly.newPlot("canvas", data, layout, {
            displayModeBar: false,
            responsive: true,
        });
    },
};
</script>